import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { WithStyles } from 'decorators/withStyles';
import { ICampaign } from 'interfaces/campaign';
import { ITheme } from 'interfaces/theme';
import React, { PureComponent } from 'react';
import rxjsOperators from 'rxjs-operators';
import { campaignService } from 'services/campaignService';
import { themeService } from 'services/themeService';

interface IProps {
  classes?: any;
}

interface IState {
  campaigns?: ICampaign[];
  selectedTheme?: ITheme;
}

@WithStyles(() => ({
  title: {
    margin: 0,
    fontWeight: 'bold',
    color: '#596375',
    fontSize: '16px'
  },
  content: {
    display: 'flex',
    flexDirection: 'column',
    paddingBottom: 50
  },
  label: {
    color: '#596375',
    fontFamily: 'Lato',
    fontSize: 16
  },
  noCampaing: {
    margin: '10px 0',
    fontStyle: 'italic'
  }
}))
export default class Campaigns extends PureComponent<IProps, IState> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      campaigns: null
    };
  }

  componentDidMount() {
    campaignService
      .getCampaigns()
      .pipe(rxjsOperators.bindComponent(this))
      .subscribe(campaigns => {
        this.setState({ campaigns });
      });

    themeService
      .getSelectedTheme()
      .pipe(rxjsOperators.bindComponent(this))
      .subscribe(selectedTheme => this.setState({ selectedTheme }));
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  linkTheme = (campaignId: number, themeId: string, event: any): any => {
    let campaigns = this.state.selectedTheme.campaigns;
    const hasCampaign = campaigns.includes(Number(campaignId));

    if (!hasCampaign) {
      campaigns.push(campaignId);
    }

    if (hasCampaign) {
      const index = campaigns.indexOf(campaignId);
      campaigns.splice(index, 1);
    }
    this.setState({
      selectedTheme: {
        ...this.state.selectedTheme,
        campaigns
      }
    });

    campaignService
      .enableDisableCampaign(campaignId, themeId)
      .pipe(rxjsOperators.loader(), rxjsOperators.bindComponent(this))
      .subscribe(() => {});
  };

  render() {
    const { classes } = this.props;
    const { campaigns, selectedTheme } = this.state;

    if (!this.state.campaigns || !selectedTheme) {
      return null;
    }

    return (
      <div className={classes.content}>
        <h3 className={classes.title}>Ativar nas campanhas</h3>
        {campaigns.length < 1 ? (
          <div className={classes.noCampaing}>Você não possui nenhuma campanha</div>
        ) : (
          campaigns.map((campaign: ICampaign, key: number) => {
            return (
              <FormControlLabel
                key={key}
                classes={{ label: classes.label }}
                label={campaign.name}
                control={
                  <Switch
                    disableRipple
                    checked={selectedTheme.campaigns.includes(Number(campaign.id))}
                    onChange={this.linkTheme.bind(this, campaign.id, selectedTheme.id)}
                    value={campaign.name}
                  />
                }
              />
            );
          })
        )}
      </div>
    );
  }
}
